import styled, { css } from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { greyMui } from "@ryde/theme";

interface ILiveMapPollProgressRingWrapStyledProps extends IStyledAttributes {
  $withCenterIcon?: boolean;
}

export const LiveMapPollProgressRingWrapStyled = styled.div.attrs<ILiveMapPollProgressRingWrapStyledProps>(
  {
    [DATA_E2E_KEY]: "live-map-poll-progress-ring",
  },
)<ILiveMapPollProgressRingWrapStyledProps>`
  position: relative;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  ${({ $withCenterIcon }) =>
    $withCenterIcon
      ? css`
          width: 26px;
          height: 26px;
        `
      : css`
          width: 20px;
          height: 20px;
        `}

  .MuiCircularProgress-root,
  .MuiCircularProgress-circle {
    transition: none;
  }

  .live-map-poll-progress-track {
    position: absolute;
    inset: 0;
    margin: auto;
    color: ${greyMui._100};
  }

  .live-map-poll-progress-indicator {
    position: absolute;
    inset: 0;
    margin: auto;
    color: ${greyMui._400};
  }

  .live-map-poll-progress-center {
    position: relative;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 0;
  }
`;
